import React, { forwardRef, SyntheticEvent, useCallback, useEffect, useImperativeHandle, useState } from "react";
import FocusTrap from "focus-trap-react";
import { TRIGGER_CONTAINER_IDS } from "../../constants";
import TriggerButton from "../TriggerButton";
import styles from "./styles.module.scss";

const {
  backdrop,
  backdropIsOpen,
  layer,
} = styles

export type LayerHandle = {
  handleToggleOverlay: () => void;
}
export const Layer = forwardRef<LayerHandle, { children: React.ReactNode }>((props, ref) => {
  const { children } = props

  const [initialBodyOverflowProp] = useState(document.body.style.overflowY)
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)

  useImperativeHandle(ref, () => ({
    handleToggleOverlay,
  }));

  const handleToggleOverlay = () => {
    setIsOverlayOpen((prevState) => !prevState)
  }

  const handleClickOutside = useCallback(() => {
    setIsOverlayOpen(false)
  }, [])

  /*
   * needed to stop closing layer when clicked
   * */
  const stopEventPropagation = (event: SyntheticEvent) => event.stopPropagation()

  /*
   * toggle overflow css on body to suppress scrolling on body if layer is open
   * */
  useEffect(() => {
    const bodyElement = document.body
    bodyElement.style.overflowY = isOverlayOpen ? 'hidden' : initialBodyOverflowProp
  }, [isOverlayOpen])

  return <>
    {TRIGGER_CONTAINER_IDS.map((containerId: string) => (
      <TriggerButton
        key={containerId}
        containerId={containerId}
        onClick={handleToggleOverlay}
      />
    ))}

    <div
      className={`${backdrop}${isOverlayOpen ? ' ' + backdropIsOpen : ''}`}
      onClick={handleClickOutside}
    >
      <FocusTrap
        active={isOverlayOpen}
        focusTrapOptions={{
          onPostDeactivate: () => {
            setIsOverlayOpen(false)
          },
          clickOutsideDeactivates: true,
          returnFocusOnDeactivate: true,
        }}
      >
        <div className={layer} onClick={stopEventPropagation}>
          {children}
        </div>
      </FocusTrap>
    </div>
  </>
})